<template>
  <v-card outlined>
    <v-card-title> Tasks </v-card-title>
    <v-data-table
      :items="list"
      :headers="headers"
      :loading="loading"
      :items-per-page="1000"
      mobile-breakpoint="0"
      class="row-pointer"
      @click:row="rowClick"
    >
      <template #[`item.id`]="{ item }">
        <router-link
          v-if="item.type === 'Review'"
          :to="`/orders/${item.id}`"
        >
          {{ item.id }}
        </router-link>
        <template v-else>
          {{ item.id }}
        </template>
      </template>
      <template #[`item.name`]="{ item }">
        <router-link
          v-if="item.userId"
          :to="`/users/${item.userId}`"
        >
          {{ item.name }}
        </router-link>
        <template v-else>
          {{ item.name }}
        </template>
      </template>
      <template #[`item.modifiedDate`]="{ item }">
        {{ item.modifiedDate | normalDateWithTime }}
      </template>
      <template #[`item.actions`]="{}">
        <v-icon>more_vert</v-icon>
      </template>
    </v-data-table>
    <TemplatesEdit @reload="loadData" />
    <EditReview />
  </v-card>
</template>

<script>
import EditReview from '@/components/reviews/Edit';
import TemplatesEdit from '@/components/templates/Edit';
import { mapGetters } from 'vuex';
export default {
  name: 'CatalogTemplates',
  components: {
    TemplatesEdit,
    EditReview
  },
  data: () => {
    return {
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Type', value: 'type' },
        { text: 'Contributor', value: 'contributor' },
        {
          text: 'Modified',
          value: 'modifiedDate'
        },
        { text: 'Status', value: 'status' },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false
    };
  },
  computed: {
    list() {
      return this.templates
        .filter((x) => x.canPublish)
        .map((x) => ({
          id: x.id,
          type: 'Template',
          name: x.name,
          status: 'Not Published',
          designGroupName: x.designGroup.nameHierarchy,
          modifiedDate: x.modifiedDate,
          showEvent: this.$enums.EVENT_BUS_EVENTS.EDIT_TEMPLATE_SHOW
        }))
        .concat(
          this.reviews
            .filter((x) => x.statusId === this.$enums.REVIEW_STATUS.PENDING)
            .map((x) => ({
              id: x.orderId,
              type: 'Review',
              name: x.nameAndCompany,
              status: 'Pending',
              modifiedDate: x.date,
              showEvent: this.$enums.EVENT_BUS_EVENTS.REVIEW_EDIT_SHOW,
              userId: x.userId
            }))
        );
    },
    ...mapGetters({
      templates: 'templates/list',
      reviews: 'reviews/list'
    })
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      const calls = [this.$store.dispatch('templates/loadTasks')];
      calls.push(this.$store.dispatch('reviews/load'));
      Promise.all(calls)
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rowClick(item) {
      this.$bus.$emit(item.showEvent, {
        id: item.id
      });
    }
  }
};
</script>
